module.exports = __webpack_public_path__ + "img/team-1.51656ad.webp";